import { Component, h, Prop, Watch } from '@stencil/core';
import { stringFormat, toLocalSeparator } from '@ugc-utils/utils';
import state from '@ugc-store';
import { getReviewSummary } from '@ugc-api/review';
import { toSummary, getSummaryThumbStatusData } from '@ugc-components/ugc-pdp-review/utils';
@Component({
  tag: 'ugc-review-ratings',
  shadow: false,
})
export class UgcReviewRatings {
  @Prop() productId: number;

  async getReviewSummaryData() {
    const {
      preference: { language },
    } = state;
    try {
      const summaryData = (await getReviewSummary(this.productId, language)) || {};
      state.reviewSummary = toSummary(summaryData);
      if (state.isDesktop) {
        await getSummaryThumbStatusData();
      }
    } catch (e) {}
  }

  async componentWillLoad() {
    this.getReviewSummaryData();
  }

  @Watch('productId')
  async watchProductIdHandler() {
    this.getReviewSummaryData();
  }

  render() {
    const {
      reviewStaticLanguage: { IDS_REVIEWS_BASE_ON_RATINGS = '' } = {},
      reviewSummary: { averageRating = 0, calculatedRating = 0, count = 0 },
      ids = [],
      isDesktop,
      isShowReviewSkeleton,
    } = state;

    if (isShowReviewSkeleton) return <ugc-review-summary-skeleton />;

    return (
      ids.length > 0 && (
        <div class={`w-full ${isDesktop ? 'mb-24' : ''} flex-row-center-center gap-16`}>
          <h2 class={`${isDesktop ? 'ft-64' : 'ft-48'} m-0 bold -center color-gray-700 shrink-0`}>{averageRating}</h2>
          <div class="ratings-star flex-col-center-start">
            <ugc-star withTips={false} disabled={true} size={24} hoverValue={calculatedRating} />
            <span class="mt-4 fs-14 lh-24 color-gray-600">
              {stringFormat(IDS_REVIEWS_BASE_ON_RATINGS, toLocalSeparator(count || 0))}
            </span>
          </div>
        </div>
      )
    );
  }
}
